export default __webpack_public_path__ + "static/media/AbhayaLibre-ExtraBold.75699413.ttf";